import Footer from "./components/Footer";
import Header from "./components/Header";
import HomePage from "./components/Home-page";

function App() {
  return (
    <div className="App">
      <Header />
      <HomePage />
      <Footer />
    </div>
  );
}

export default App;
